import { getParent, types, type Instance } from 'mobx-state-tree';

/** The OET tools (the `activeTool` enumeration). */
type OETTool = 'select' | 'add_method' | 'add_event' | 'add_specialised_event' | 'delete';

// The OET store's parent is the UI store; the OET view only reads
// `highlightedMethods` from it. Narrow structural interface to avoid an import
// cycle with the UI store (which embeds OET).
interface IOETUIParent {
  readonly highlightedMethods: string[];
}

/**
 * UI state for the OET view
 */
const OET = types
  .model('UIOET', {
    // which tool is active
    activeTool: types.maybeNull(
      types.enumeration(['select', 'add_method', 'add_event', 'add_specialised_event', 'delete'])
    ),
    // the id of the column that is currently being dragged
    draggedColumn: types.maybeNull(types.string),
  })
  .views((self) => ({
    get highlightedMethods() {
      const ui = getParent<IOETUIParent>(self);
      return ui.highlightedMethods;
    },
  }))
  .actions((self) => ({
    toggleTool(tool: OETTool) {
      if (self.activeTool === tool) {
        self.activeTool = null;
      } else {
        self.activeTool = tool;
      }
    },
    deactivateTool() {
      self.activeTool = null;
    },
    setDraggedColumn(column: string | null) {
      self.draggedColumn = column;
    },
  }));

export type IUIOET = Instance<typeof OET>;

export default OET;
